module.exports = __webpack_public_path__ + "img/logo.a561c60b.png";